import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@chakra-ui/react";
import { useStaticQuery } from "gatsby";
import MenuStructure from "../../structure/MenuStructure/MenuStructure";
import { findT } from "../../_helpers";
import { GlobalContext } from "../../../providers";
import { jsx as ___EmotionJSX } from "@emotion/react";
const DEFAULT_MENU = [{
  displayName: "Impressum",
  path: "/impressum"
}, {
  displayName: "Datenschutz",
  path: "/datenschutz"
}];
const NavigationWidget = props => {
  const {
    setShowCookieBanner
  } = useContext(GlobalContext);
  const {
    0: defaultMenu,
    1: setDefaultMenu
  } = useState(DEFAULT_MENU);
  const data = useStaticQuery(query);
  const translations = findT(props.widget.translations, props.lang);
  const showAccessibility = data.directusProject.show_accessibility;
  useEffect(() => {
    if (showAccessibility) {
      let menu = DEFAULT_MENU;
      menu.push({
        displayName: "Barrierefreiheit",
        path: "/barrierefreiheit"
      });
      setDefaultMenu(menu);
    }
  }, [showAccessibility]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h4", null, translations.header ? translations.header : ___EmotionJSX(FormattedMessage, {
    id: "components.widgets.navigationWidget.defaultHeader"
  })), ___EmotionJSX("nav", null, ___EmotionJSX(MenuStructure, {
    menu: defaultMenu
  }), ___EmotionJSX("div", {
    id: "int-shop-menu"
  })), ___EmotionJSX(Button, {
    onClick: () => setShowCookieBanner(true),
    variant: "link",
    color: "unset",
    textDecoration: "underline",
    fontWeight: "300"
  }, "Cookie Einstellungen"));
};
export default NavigationWidget;
const query = "2857179422";